var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('main',{attrs:{"id":"main-container"}},[_c('Navbar'),_c('router-view')],1),_c('footer',{attrs:{"id":"page-footer"}})])}
var staticRenderFns = []

export { render, staticRenderFns }